<template>
  <div class="TextoPoliticaPrivacidad p-2" style="text-align: justify">
    <h6 class="fw-bold">1. IDENTIFICACIÓN DEL RESPONSABLE Y CANAL DE CONTACTO</h6>
    <p>
      La plataforma <strong>RiskMann by SOFU</strong> es de propiedad exclusiva de <strong>SOFU BIC S.A.S.</strong>, sociedad comercial legalmente constituida bajo las leyes de la República de Colombia.
      <br /><br />
      En cumplimiento de la Ley Estatutaria 1581 de 2012 y el Decreto 1377 de 2013, se establece como canal único y oficial para la atención de consultas, reclamos y solicitudes de Habeas Data el correo electrónico: <strong>riskmann@sofu.com.co</strong>.
    </p>

    <h6 class="fw-bold mt-4">2. FINALIDAD Y TRATAMIENTO DE LA INFORMACIÓN</h6>
    <p>
      Al aceptar esta política, el titular autoriza expresamente a SOFU BIC S.A.S. para recolectar, almacenar, procesar, consultar, actualizar y custodiar los datos personales suministrados. Dichos datos serán tratados exclusivamente para:
      <br />
      • La gestión operativa de seguridad vial, planes de desplazamiento, inspecciones preoperacionales vehiculares y reporte de siniestros viales (PESV).
      <br />
      • El control de asistencia laboral y registro de actividades mediante códigos QR y formularios operativos.
      <br />
      • El registro sociodemográfico laboral con fines estrictamente preventivos en el entorno de trabajo.
      <br />
      • El envío de notificaciones del sistema, reportes operativos e informes solicitados por la organización cliente.
      <br /><br />
      <em>SOFU BIC S.A.S. no comercializa, no cede a terceros ni utiliza la información personal para fines publicitarios externos o crediticios.</em>
    </p>

    <h6 class="fw-bold mt-4">3. DATOS DE SALUD Y OCUPACIONALES</h6>
    <p>
      El usuario reconoce que en el marco de la prevención de riesgos y la seguridad vial se pueden registrar datos relacionados con aptitudes psicofísicas o reportes de condiciones de salud en inspecciones operativas.
      <br /><br />
      El suministro de datos sensibles es facultativo, salvo que exista un deber legal u ocupacional que exija su registro. Dicha información será tratada con <strong>estricta reserva y confidencialidad</strong>, orientada únicamente a la mitigación de riesgos de la empresa contratante.
    </p>

    <h6 class="fw-bold mt-4">4. ROL DE SOFU Y RESPONSABILIDAD DE LA EMPRESA EMPLEADORA</h6>
    <p>
      Respecto a la información registrada sobre trabajadores, vehículos y operaciones, <strong>la empresa empleadora o contratante actúa en calidad de Responsable del Tratamiento</strong>, mientras que <strong>SOFU BIC S.A.S. actúa exclusivamente como Encargado del Tratamiento tecnológico</strong>.
      <br /><br />
      La empresa cliente declara y garantiza contar con la autorización previa, expresa e informada de todos los trabajadores, conductores y colaboradores que vincula a la plataforma. SOFU BIC S.A.S. no se hace responsable por la falta de autorización que el empleador haya omitido recabar frente a su personal.
    </p>

    <h6 class="fw-bold mt-4">5. ALOJAMIENTO EN LA NUBE Y TRANSMISIÓN INTERNACIONAL</h6>
    <p>
      Para garantizar el funcionamiento seguro y continuo de la plataforma, el titular autoriza expresamente la transmisión de sus datos a servidores e infraestructura de computación en la nube (como Google Cloud Platform / Firebase), los cuales operan bajo estrictos estándares internacionales de seguridad informática y cifrado.
    </p>

    <h6 class="fw-bold mt-4">6. DERECHOS DEL TITULAR Y TIEMPOS LEGALES DE RESPUESTA</h6>
    <p>
      El titular podrá ejercer sus derechos de conocer, actualizar, rectificar o solicitar la supresión de sus datos personales, así como revocar la autorización otorgada, enviando su solicitud escrita a <strong>riskmann@sofu.com.co</strong>.
      <br /><br />
      De conformidad con los artículos 14 y 15 de la Ley 1581 de 2012, las <strong>consultas</strong> serán atendidas en un término máximo de diez (10) días hábiles (prorrogables legalmente por 5 días hábiles más), y los <strong>reclamos</strong> de corrección o supresión se resolverán en un término máximo de quince (15) días hábiles (prorrogables legalmente por 8 días hábiles más). La supresión de datos no procederá cuando exista un deber legal o contractual que obligue a conservar la información.
    </p>
  </div>
</template>

<script>
export default {
  name: "TextoPoliticaPrivacidad",
};
</script>
